
import { JavaScriptCourse } from './types';
import { JS_FUNDAMENTALS_COURSE } from './fundamentals';
import { JS_INTERMEDIATE_COURSE } from './intermediate';
import { JS_ADVANCED_COURSE } from './advanced';

export const JAVASCRIPT_COURSES: JavaScriptCourse[] = [
  JS_FUNDAMENTALS_COURSE,
  JS_INTERMEDIATE_COURSE,
  JS_ADVANCED_COURSE
];

// Export individual courses for direct access
export { 
  JS_FUNDAMENTALS_COURSE,
  JS_INTERMEDIATE_COURSE,
  JS_ADVANCED_COURSE
};

// Export types
export * from './types';

// Course metadata for easy reference
export const JAVASCRIPT_COURSE_METADATA = {
  totalCourses: JAVASCRIPT_COURSES.length,
  totalDuration: '30-37 hours',
  levels: ['fundamentals', 'intermediate', 'advanced'],
  skillsPath: [
    'JavaScript Syntax & Fundamentals',
    'DOM Manipulation & Events',
    'Asynchronous Programming',
    'Advanced Functions & Closures',
    'Design Patterns',
    'Performance Optimization',
    'Testing & Debugging',
    'Modern Development Practices'
  ]
};
